var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"10","md":"10"}},[_c('span',{staticClass:"titulo-header"},[_vm._v("Cotizaciones")])])],1),(_vm.globalConfig.showMainHubGraphs)?_c('div',{staticStyle:{"padding-top":"30px"}},[_c('StatsCotizaciones')],1):_vm._e(),_c('div',{staticStyle:{"padding-top":"30px"}},[_c('FiltersCotizacionesIndex')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }